var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"advisory"},[_c('div',{staticStyle:{"max-width":"100%","margin-left":"auto","margin-right":"auto"}},[_c('iframe',{staticStyle:{"width":"100%","height":"100vh"},attrs:{"src":"https://www.easy-insight.com/a/dashboard/AkgPgXmLamnxZyg/embed"}})])])
}]

export { render, staticRenderFns }